package one.healthium.today.di

import org.koin.dsl.module

val todayUiMedModule = module {
    includes(todayModule)
}